import { RefObject } from 'react';
import useDebounce from './useDebounce';
import useSearchQuery from '../features/App/components/AppHeader/useSearchQuery';
import useDidUpdateEffect from './useDidUpdate';

export function useScrollOnSearch(
  ref: RefObject<HTMLDivElement>,
  debounceTime: number,
  offsetY?: number,
) {
  const { searchQuery } = useSearchQuery();
  const searchQueryDebounced = useDebounce(searchQuery, debounceTime);

  useDidUpdateEffect(() => {
    if (searchQueryDebounced && ref.current) {
      const y =
        ref.current.getBoundingClientRect().top +
        window.scrollY +
        (offsetY || 0);

      window.scroll({
        top: y,
        behavior: 'smooth',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQueryDebounced]);
}
